import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

export default class tableDepositReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const id_partner = this.getParam('partner', true); // Retrieve partner ID from parameters
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var direction = false; // Variable to hold sorting direction
        var vthis = this; // Reference to the current instance

        // Custom data filter for summing tree column
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result for summation
                    var resultFormat = 0; // Initialize formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                    });
                    // Format result based on column ID
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Update node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extend from summColumn filter
        );

        // Custom data filter for summing column
        webix.ui.datafilter.mySummColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Initialize result for summation
                    var resultFormat = 0; // Initialize formatted result
                    var size = $$('datatable4').getPager().config.size; // Get page size
                    var page = $$('datatable4').getPage(); // Get current page
                    var first = size * page; // Calculate first item index
                    var last = first + size - 1; // Calculate last item index
                    var count = 0; // Initialize count for iteration
                    master.data.each(function (obj) {
                        if (count >= first && count <= last) {
                            result += parseFloat(obj[value.columnId]); // Sum values within current page
                        }
                        count++;
                    });
                    resultFormat = webix.i18n.priceFormat(result); // Format result
                    node.firstChild.innerHTML = resultFormat; // Update node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extend from summColumn filter
        );

        // Return the layout configuration
        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'wide',
                            view: 'datatable', // Define a datatable view
                            id: 'datatable4', // Set ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            columns: [
                                {
                                    id: 'detailTittle', // Column ID
                                    header: '', // Column header
                                    width: 70, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip text
                                    template: function (obj) {
                                        if (obj.State === 'A') {
                                            if (devConfig.getPermAction('depositRequestsShopDecline', 'Pay')) {
                                                return (
                                                    "<span class='webix_icon wxi-close details prm-depositRequestsShopDecline'></span>" +
                                                    "<span placeholder='Pagar' class='webix_icon wxi-close icon-tranfer prm-depositRequestsShopDecline'></span>"
                                                ); // Return HTML for action icons
                                            }
                                        }
                                        return "<span class='webix_icon wxi-close details'></span>"; // Default icon
                                    },
                                    footer: 'Total:', // Footer text
                                },
                                { id: 'Id', header: 'ID', width: 100 }, // ID column
                                {
                                    id: 'ClientId',
                                    header: _('ID Usuario'), // User ID column with localization
                                    width: 100,
                                },
                                {
                                    id: 'CreatedLocal',
                                    header: _('Fecha de Creación'), // Creation date column with localization
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 150,
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'Provider',
                                    header: _('Proveedor'), // Provider column with localization
                                    width: 150,
                                },
                                {
                                    id: 'PaymentSystemName',
                                    header: _('Nombree Sistema Pasarela Pago'), // Payment system name column with localization
                                    width: 250,
                                },
                                {
                                    id: 'TypeName',
                                    header: _('Tipo'), // Type column with localization
                                    width: 100,
                                },
                                {
                                    id: 'CurrencyId',
                                    header: _('Moneda'), // Currency column with localization
                                    width: 100,
                                },
                                {
                                    id: 'Amount',
                                    header: _('Valor'), // Amount column with localization
                                    width: 100,
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'mySummColumn' }, // Custom footer content
                                    editor: 'text', // Editor type
                                },
                                {
                                    id: 'ModifiedLocal',
                                    header: _('Modificado'), // Modified date column with localization
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 150,
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'State',
                                    header: _('Estado'), // State column with localization
                                    options: [
                                        { id: '', value: _('None') }, // None option
                                        { id: 'A', value: _('Pagada') }, // Paid option
                                        { id: 'C', value: _('Cancelado') }, // Canceled option
                                        { id: 'I', value: _('Inactivo') }, // Inactive option
                                        { id: 'R', value: _('Rechazada') }, // Rejected option
                                    ],
                                },
                                {
                                    id: 'ExternalId',
                                    header: _('External ID'), // External ID column with localization
                                    width: 150,
                                },
                                { id: 'Ip', header: 'IP', width: 150 }, // IP column
                                {
                                    id: 'CashDeskId',
                                    header: _('Recepcion de Efectivo'), // Cash desk column with localization
                                    width: 150,
                                },
                            ],
                            onClick: {
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get item by ID
                                    this.$scope.app.callEvent('deposit:id', [
                                        item.Id, // Call event with item ID
                                    ]);
                                    $$('dColl').expand(); // Expand detail section
                                    $$('a5').scrollTo(0, 1000); // Scroll to specific position
                                },
                                'icon-tranfer': function (euv, id) {
                                    var vvthis = this; // Reference to current instance
                                    var item = vvthis.getItem(id); // Get item by ID
                                    webix
                                        .modalbox({
                                            id: 'modalAgent', // Modal ID
                                            title: _('¿ Qué desea realizar ?'), // Modal title with localization
                                            buttons: [
                                                'Rechazar Depósito', // Reject deposit button
                                                'Cancelar', // Cancel button
                                            ],
                                            text: '',
                                            width: 500,
                                        })
                                        .then(function (result) {
                                            var state; // Variable to hold state
                                            switch (result) {
                                                case '0':
                                                    state = '1'; // Set state based on result
                                                    break;
                                            }
                                            console.log(result); // Log result
                                            if (result === '0') {
                                                var tthis = this; // Reference to current instance
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type for AJAX request
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Financial/ActionDepositUser', // API endpoint
                                                        '{ "Id":' +
                                                            item.Id +
                                                            ', "State":"' +
                                                            state +
                                                            '", "Partner":"' +
                                                            id_partner +
                                                            '"}', // Request body
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    'Error! ', // Show error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var data = JSON.parse(
                                                                    text, // Parse response data
                                                                );
                                                                if (data.HasError) {
                                                                    webix.message(
                                                                        'No se proceso la solicitud. Comunicarse con soporte. ', // Show error message
                                                                    );
                                                                    tthis.getTopParentView().hide(); // Hide modal
                                                                } else {
                                                                    item.State = 'I'; // Update item state
                                                                    webix.message(
                                                                        'Se ha se procesado la solicitud satisfactoriamente. ', // Show success message
                                                                    );
                                                                    tthis.getTopParentView().hide(); // Hide modal
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        });
                                },
                            },
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Show no data message
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            footer: true, // Enable footer
                            math: true, // Enable math operations
                            loadahead: 0, // Set load ahead
                            datafetch: devConfig.getDefaultDataFetch(), // Set default data fetch
                            pager: 'pagerA', // Set pager ID
                        },
                        {
                            type: 'wide',
                            scrollY: screen.width < 820 ? false : true, // Enable/disable vertical scroll based on screen width
                            view: 'treetable', // Define a tree table view
                            id: 'datatable2', // Set ID for the tree table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            columns: [
                                {
                                    id: 'CreatedLocal',
                                    header: _('Fecha de Creación'), // Creation date column with localization
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 200,
                                    format: dateFormat, // Date formatting
                                    template: function (obj, common) {
                                        if (obj.$group)
                                            return (
                                                common.treetable(obj, common) + obj.value // Return grouped value
                                            );
                                        return obj.CreatedLocal; // Return creation date
                                    },
                                },
                                {
                                    id: 'PaymentSystemName',
                                    header: _('Nombre Sistema Pasarela Pago'), // Payment system name column with localization
                                    width: 250,
                                },
                                {
                                    id: 'CurrencyId',
                                    header: _('Moneda'), // Currency column with localization
                                    width: 100,
                                },
                                {
                                    id: 'Amount',
                                    header: _('Valor'), // Amount column with localization
                                    width: 100,
                                    format: webix.i18n.priceFormat, // Price formatting
                                    exportType: 'number', // Export type
                                    footer: { content: 'summTreeColumn' }, // Custom footer content
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                console.log('count ' + this.count()); // Log item count
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Show no data message
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            footer: true, // Enable footer
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Set load ahead
                            pager: {
                                size: 10000, // Set pager size
                                id: 'pagerr', // Set pager ID
                            },
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        const id_partner = this.getParam('partner', true); // Retrieve partner ID from parameters
        var gridppal = $$('datatable4'); // Main datatable reference
        var grid2 = $$('datatable2'); // Secondary datatable reference
        var url = devConfig.geturlApi() + 'es/Financial/GetDepositsWithdrawalsWithPaging2?Partner=' + id_partner + '&'; // API endpoint for deposits/withdrawals
        var url2 = devConfig.geturlApi() + 'es/Financial/GetDepositsWithdrawalsWithPaging2?Partner=' + id_partner + '&'; // Duplicate API endpoint for secondary grid
        gridppal.hide(); // Hide main datatable initially
        var flag = false; // Flag for export operations
        $$('toolbar').hide(); // Hide toolbar initially
        grid2.attachEvent('onAfterLoad', function () {
            $$('datatable2').data.group({
                by: 'Provider', // Group by provider
                map: {
                    Provider: ['Provider'],
                    Country: ['Country'],
                    Amount: ['Amount', 'sum'], // Sum amounts
                },
            });
            $$('datatable2').data.group({
                by: function (obj) {
                    return (
                        "<i class='flags " + obj.CountryIcon + "'></i>" + obj.Country // Group by country with icon
                    );
                },
                map: {
                    Amount: ['Amount', 'sum'], // Sum amounts
                },
            });
        });
        var filter = ''; // Initialize filter string
        this.on(this.app, 'depositReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize first filter string
            var string2 = ''; // Initialize second filter string
            var providergroup = 0; // Initialize provider group flag
            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'IsDetails') {
                    if (object[i][1] == 0) {
                    } else {
                        providergroup = 1; // Set provider group flag
                    }
                }
                if (object[i][0] == 'Sort' && providergroup == 0) {
                    if (object[i][1] == '1') {
                        string2 = string2 + '&sort[ClientId]='; // Sort by ClientId
                    } else {
                        if (object[i][1] == '2') {
                            string2 = string2 + '&sort[CreatedLocal]='; // Sort by CreatedLocal
                        } else {
                            if (object[i][1] == '3') {
                                string2 = string2 + '&sort[Amount]='; // Sort by Amount
                            }
                        }
                    }
                }
                if (object[i][0] == 'Dir' && providergroup == 0) {
                    if (object[i][1] == '0') {
                        string2 = string2 + 'asc'; // Ascending order
                    } else {
                        if (object[i][1] == '1') {
                            string2 = string2 + 'desc'; // Descending order
                        }
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        if (object[i][0] != 'Sort' && object[i][0] != 'Dir') {
                            if (object[i][0] != 'Date') {
                                string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                            } else {
                                if (object[i][0] == 'Date') {
                                    var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                    string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter
                                    string1 = string1 + '&dateTo=' + date; // Add dateTo to filter
                                }
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Add partner ID to filter
            if (providergroup == 0) {
                gridppal.show(); // Show main datatable
                grid2.hide(); // Hide secondary datatable
                gridppal.clearAll(); // Clear main datatable
                gridppal.load(
                    url + '?start=0&count=' + gridppal.data.$pagesize + string1 + string2, // Load data with filters
                );
                $$('toolbar').show(); // Show toolbar
                $$('toolbar2').hide(); // Hide secondary toolbar
            } else {
                $$('dColl').collapse(); // Collapse detail section
                grid2.show(); // Show secondary datatable
                gridppal.hide(); // Hide main datatable
                grid2.clearAll(); // Clear secondary datatable
                grid2.load(
                    url2 + '?start=0&count=' + grid2.data.$pagesize + string1 + string2, // Load data with filters
                );
                grid2.adjust(); // Adjust secondary datatable
                $$('toolbar2').show(); // Show secondary toolbar
                $$('toolbar').hide(); // Hide main toolbar
            }
            filter = string1 + string2; // Update filter string
        });

        // Event handler for export filter
        this.on(this.app, 'export:filter', (filterData) => {
            console.log(filterData); // Log filter data
            flag = true; // Set export flag
            var firstfirst;
            if (filterData.first == 0) {
                firstfirst = filterData.first + 1; // Adjust first index
            } else {
                firstfirst = filterData.first; // Use original first index
            }
            gridppal.load(
                url + '?start=' + firstfirst + '&count=' + (filterData.last + 1) + filter, // Load data for export
            );
            $$('datatable4').attachEvent(
                'onAfterLoad',
                function () {
                    if (flag) {
                        var size = $$('datatable4').getPager().config.size; // Get pager size
                        var page = $$('datatable4').getPage(); // Get current page
                        var first = size * page; // Calculate first item index
                        var last = first + size - 1; // Calculate last item index
                        if ($$('Export').getValue() == '1') {
                            for (var j = 0; j < gridppal.config.columns.length; j++) {
                                if (gridppal.config.columns[j].exportType) {
                                    delete gridppal.config.columns[j].format; // Remove format for export
                                }
                            }
                            this.app.callEvent('export:data', [
                                {
                                    NameReport:
                                        'Depósitos' +
                                        ($$('datatable4').count() > 0 ? '' : _(' - No hay datos')) +
                                        ' - ' +
                                        new Date().toLocaleString(), // Report name
                                    TypeReport: 'Excel', // Report type
                                },
                            ]);
                            webix.toExcel(gridppal, {
                                filter: function (obj) {
                                    return (
                                        $$('datatable4').getIndexById(obj.id) >= first &&
                                        $$('datatable4').getIndexById(obj.id) <= last // Filter for export
                                    );
                                },
                                filename:
                                    'Virtualsoft - ' +
                                    new Date()
                                        .toLocaleString('en-GB', {
                                            hour12: true,
                                        })
                                        .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                        .replace(/[\/:]/g, '_')
                                        .toUpperCase() +
                                    ' - ' +
                                    ($$('datatable4').count() > 0 ? '' : _('No hay datos - ')) +
                                    'Depósitos', // Filename for export
                                ignore: { detailTittle: true }, // Ignore specific column
                                footer: false, // Do not include footer in export
                            });
                        } else {
                            if ($$('Export').getValue() == '2') {
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            'Depósitos' +
                                            ($$('datatable4').count() > 0 ? '' : _(' - No hay datos')) +
                                            ' - ' +
                                            new Date().toLocaleString(), // Report name
                                        TypeReport: 'PDF', // Report type
                                    },
                                ]);
                                webix.toPDF($$('datatable4'), {
                                    filter: function (obj) {
                                        return (
                                            $$('datatable4').getIndexById(obj.id) >= first &&
                                            $$('datatable4').getIndexById(obj.id) <= last // Filter for export
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable4').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Depósitos', // Filename for export
                                    autowidth: true, // Auto width for PDF
                                    ignore: { detailTittle: true }, // Ignore specific column
                                    footer: false, // Do not include footer in export
                                });
                            }
                        }
                        flag = false; // Reset export flag
                        $$('Export').setValue(''); // Reset export selection
                    }
                }.bind(this),
            );
        });

        // Event handler for sorting in main datatable
        gridppal.attachEvent('onAfterSort', function (by, dir, as) {
            console.log('as: ' + as); // Log sorting direction
            gridppal.load(
                url + '?start=0&count=' + gridppal.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load data with sorting
            );
        });

        // Event handler for sorting in secondary datatable
        grid2.attachEvent('onAfterSort', function (by, dir, as) {
            grid2.load(
                url + '?start=0&count=' + grid2.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load data with sorting
            );
        });

        // Event handler for player selection
        this.on(this.app, 'player:select', (Id) => {
            gridppal.load(
                url + '?start=0&count=' + gridppal.data.$pagesize + '&PlayerId=' + Id, // Load data filtered by player ID
            );
        });
    }
}

// FILE DOCUMENTED
